module.exports = __webpack_public_path__ + "img/axsold.68be2e64.svg";